export enum MessageType {
  Question,
  Suggestion,
  BugReport,
}
